import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Footer from "../../components/Footer";
import { Container, Main } from "./styles";

interface ErrorPageProps {
  status?: "403" | "404" | "500";
}

function ErrorPage({ status = "404" }: ErrorPageProps) {
  const navigate = useNavigate();

  const getErrorContent = () => {
    switch (status) {
      case "403":
        return {
          title: "Acesso Negado",
          subTitle:
            "Desculpe, você não tem permissão para acessar esta página.",
        };
      case "500":
        return {
          title: "Erro no Servidor",
          subTitle: "Desculpe, algo deu errado em nossos servidores.",
        };
      case "404":
      default:
        return {
          title: "Página não encontrada",
          subTitle: "Desculpe, a página que você visitou não existe.",
        };
    }
  };

  const { title, subTitle } = getErrorContent();

  return (
    <Container>
      <PageHeader title={title} description="" type="public" />
      <Main>
        <div className="error-card">
          <Result
            status={status}
            title={status}
            subTitle={subTitle}
            extra={
              <Button size="large" type="primary" onClick={() => navigate("/")}>
                Voltar ao Início
              </Button>
            }
          />
        </div>
      </Main>
      <Footer />
    </Container>
  );
}

ErrorPage.defaultProps = {
  status: "404",
};

export default ErrorPage;
